<template>
  <dss-template>
    <div id="security" class="container page">

      <h2 class="title title-dash">{{ $t('dss.page.security.title') }}</h2>

      <stihl-overlay :active="!user" :spinner="true">
        <form v-if="user">

          <change-password-section :user="user" />
          <passkeys-section v-if="!user.federatedAccounts?.length"/>
          <mfa-section :user="user" />

        </form>
      </stihl-overlay>

    </div>
  </dss-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DssTemplate from '@/components/layout/DssTemplate.vue';
import Backend, { UserDTO } from '@/components//backend';
import PasskeysSection from './PasskeysSection.vue';
import MfaSection from './MfaSection.vue';
import ChangePasswordSection from '@/pages/SecurityPage/ChangePasswordSection.vue';

export default defineComponent({
  name: 'SecurityPage',
  components: { ChangePasswordSection, PasskeysSection, MfaSection, DssTemplate, },

  data() {
    return {
      user: undefined as UserDTO | undefined,
    };
  },

  mounted() {
    Backend.validateToken().then(api => api.loadUserProfile()
        .then(r => {
          this.user = r.data;
        })
        .catch(_ => this.$toast.error(this.$t('dss.page.personal.msg.userLoadErr')))
    );
  },
});
</script>
